




















































































































































































import Vue from "vue";
import Component from "vue-class-component";
import GeneralService from "../services/general-service";

@Component
export default class Prebooking extends Vue {
  private qs3 = null;
  private service = new GeneralService();
  private phone = "";
  private verify = "";
  private verified = false;
  private sentCode = false;
  private verify_try = 0;
  private api_working = false;
  private dealership = null;
  private color = null;
  private colorint = null;

  private dealership_options = [
    { value: null, text: "Preferred Dealership*" },
    { value: "Queen's Motor", text: "Queen's Motor" },
    { value: "Hashmi & Hashmi", text: "Hashmi & Hashmi" },
    { value: "Central Motors", text: "Central Motors" },
    { value: "Automotive Technologies", text: "Automotive Technologies" },
    { value: "Islamabad Motors", text: "Islamabad Motors" },
    { value: "Rawalpindi Motors", text: "Rawalpindi Motors" },
    { value: "Southern Motors", text: "Southern Motors" },
    { value: "Kaira Motors", text: "Kaira Motors" },
    { value: "Haval Experience", text: "Haval Experience" },
    { value: "Sialkot Motors", text: "Sialkot Motors" },    
  ];

  private color_options = [
    { value: null, text: "Exterior Color*" },
    { value: "Red", text: "Red" },
    { value: "Black", text: "Black" },
    { value: "Blue", text: "Blue" },
    { value: "White", text: "White" }, 
    { value: "Green", text: "Green" }, 
  ];

  private color_optionsint = [
    { value: null, text: "Interior Color*" },
    { value: "All Black", text: "All Black" },
    { value: "Red and Black", text: "Red and Black" },
    { value: "Blue and Black", text: "Blue and Black" }, 
  ];

  private qs3Options = [
    { text: "Type of Booking*", value: null },
    "Cash",
    "Lease",
  ];

  private sendCode() {
    if (this.api_working == false) {
      this.api_working = true;
      if (this.phone.length < 11) {
        alert(
          "Please enter a valid phone number in the correct format. E.g 03211234567"
        );
        return;
      }

      this.service.sendCode(this.phone).then((response) => {
        this.sentCode = true;
        localStorage["sazgarbaic_authy_code"] = response.authy_user_id;
        this.api_working = false;
      });
    }
  }

  private verifyCode() {
    if (this.api_working == false) {
      this.api_working = true;

      this.service
        .verifyCode(this.verify)
        .then((response) => {
          this.api_working = false;
          this.verified = true;
        })
        .catch((err) => {
          this.api_working = false;

          this.verify_try++;
          if (this.verify_try == 3) {
            this.verify_try = 0;
            this.sentCode = false;
          }
        });
    }
  }
}
